import { Component, OnInit } from '@angular/core';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { GestionEmpleadoRequest } from '../../../core/models/gestionEmpleadoRequest.model';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { GestionEmpleadoService } from '../../../core/services/gestionEmpleado.service';
import { A3LCompanyService } from '../../../core/services/a3LCompany.service';
import { SessionHelper } from '../../../core/helper/sessionHelper';
import { A3LCompanyWorkplaces } from '../../../core/models/a3LCompanyWorkplaces.model';
import { HttpParams } from '@angular/common/http';
import { PageList } from '../../../core/models/pageList.model';
import { A3LEmployee } from '../../../core/models/a3LEmployee.model';
import { A3LEmployeeService } from '../../../core/services/a3LEmployee.service';
import { A3LCompany } from '../../../core/models/a3Lcompany.model';
import { GestionEmpleado } from '../../../core/models/gestionEmpleado.model';
import { A3LCommonService } from '../../../core/services/a3LCommon.service';
import { A3LCommonDataEntity } from '../../../core/models/a3LCommonDataEntity.model';

@Component({
  selector: 'app-gestion-empleados-list',
  templateUrl: './gestion-empleados-list.component.html',
  styleUrls: ['./gestion-empleados-list.component.scss'],
  providers: [GestionEmpleadoService, A3LEmployeeService, A3LCompanyService, A3LCommonService],
})
export class GestionEmpleadosListComponent extends ListFormBase<GestionEmpleado> implements OnInit
{
  panelIcon = 'users'; // material icon
  panelTitle = 'Empleados';
  panelDescription = '';

  params: HttpParams;
  centros: A3LCompanyWorkplaces[];
  personTypes: A3LCommonDataEntity[] = [];
  selectedCompanyDescription: string;

  selectedCompany: number;
  centro: number;
  tipoTrabajador: number;
  codEmpleado: string;
  nif: string;
  nombreCompleto: string;
  numAfiliacion: string;

  constructor(
    protected _modelService: GestionEmpleadoService,
    protected _A3LEmployeeService: A3LEmployeeService,
    protected _A3LCompanyService: A3LCompanyService,
    protected _A3LCommonService: A3LCommonService,
    protected _router: Router,
    _route: ActivatedRoute,
    protected _messageDialog: MessageDialog,
    protected _session: SessionHelper
  ) {
    super(_modelService, _router, _route, _messageDialog, GestionEmpleado);
    this.isCrud = true;
    this.selectedCompany = this._session.LastCompanySelectedBolsaVacaciones;
  }

  ngOnInit(): void {
    setTimeout(() => {
      if (this.selectedCompany) {
        this.onSearch();
      }
    }, 60);
    this.getTiposTrabajador();
  }

  onSearch() {
    this.dataGrid.instance.beginCustomLoading('');
    this._session.LastCompanySelectedGestionEmpleados = this.selectedCompany;
    this.getDataSource();
  }

  getDataSource() {
    const params = this.setParams();
    this._A3LEmployeeService.getPagedModels(this.selectedCompany, params).subscribe(
      (response: PageList<A3LEmployee>) => {
        if (response) {
          this.dataSource = response.pageData.map(emp => ({
            ...emp,
            companyName: this.selectedCompanyDescription,
            workplaceName: this.findWorkplaceName(emp.workplaceCode)
          }));
        } else {
          this.dataSource = new Array<A3LEmployee>();
        }
        this.dataGrid.instance.endCustomLoading();
      },
      error => {
        console.error(error);
        this._messageDialog.ShowException(error);
        this.dataGrid.instance.endCustomLoading();
      }
    );
  }

  setParams(): HttpParams {
    let params = new HttpParams();
    if (this.centro) params = params.set('workplaceCode', this.centro);
    if (this.codEmpleado) params = params.set('employeeCode', `'${this.codEmpleado}'`);
    if (this.nif) params = params.set('identifierNumber', `'${this.nif}'`);
    if (this.nombreCompleto) params = params.set('completeName', `'${this.nombreCompleto}'`);
    if (this.numAfiliacion) params = params.set('ssNAF', `'${this.numAfiliacion}'`);
    if (this.tipoTrabajador || this.tipoTrabajador === 0) params = params.set('personTypeID', this.tipoTrabajador);
    return params;
  }

  cargarCentros(companyCode: string) {
    this._A3LCompanyService.getWorkplaces(companyCode, null)
    .subscribe((response) => {
      if (response) {
        this.centros = response.pageData;
      }
    }, error => {
      console.error(error);
    });
  }

  getTiposTrabajador() {
    this._A3LCommonService.getPersonTypes()
    .subscribe((response) => {
      if (response) {
        this.personTypes = response;
      }
    }, error => {
      console.error(error);
    });
  }

  onCompanyChange(selectedCompany: number): void {
    if(selectedCompany) {
      this.cargarCentros(selectedCompany.toString());
    }
  }

  onSelectedValueChange(company: A3LCompany): void {
    if(company) {
      this.selectedCompanyDescription = company.companyName;
    }
  }

  findWorkplaceName(workplaceCode: number): string {
    const centro = this.centros.find(c => c.workplaceCode === workplaceCode);
    return centro ? centro.workplaceName : '';
  }
}
